import React from 'react';
import { purple, cyan } from '@mui/material/colors';
import { useIntl } from 'react-intl';

import messages from './messages';
import Tag from '../Tag';

const ExperienceLevel = ['Newbie', 'Common', 'Mentor'] as const;

export const isValidExperienceLevel = (
  level: string
): level is (typeof ExperienceLevel)[number] =>
  ExperienceLevel.includes(level as (typeof ExperienceLevel)[number]);

type PublisherExperienceTagProps = {
  experienceLevel: (typeof ExperienceLevel)[number];
};

const PublisherExperienceTag = (
  props: PublisherExperienceTagProps
): React.JSX.Element => {
  const intl = useIntl();
  return (
    <>
      {props.experienceLevel === 'Mentor' && (
        <Tag style={{ backgroundColor: purple[50], color: purple[900] }}>
          {intl.formatMessage(messages.mentor)}
        </Tag>
      )}
      {props.experienceLevel === 'Newbie' && (
        <Tag style={{ backgroundColor: cyan[50], color: cyan[900] }}>
          {intl.formatMessage(messages.newbie)}
        </Tag>
      )}
    </>
  );
};

export default PublisherExperienceTag;
